import * as React from "react";
const BlurLoader = React.memo(({ text = 'Please wait...', imageUrl = './favicon.ico' }) => {
    return (
        <>
            <div className="main-div-blur">
                <div className='position-relative text-center'>
                    <div className="loader"></div>
                    <img src={imageUrl} loading='eager' alt=''></img>
                    <h3 className="text-center">{text}</h3>
                </div>
            </div>
        </>
    )
});

export default BlurLoader;